import React from 'react';

export const ForgeUnitoWrikeDevSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_3059_499)">
				<path
					d="M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z"
					fill="white"
				/>
				<path
					d="M23.999 0.508057H8C3.86229 0.508057 0.508003 3.86234 0.508003 8.00006V23.9991C0.508003 28.1368 3.86229 31.4911 8 31.4911H23.999C28.1367 31.4911 31.491 28.1368 31.491 23.9991V8.00006C31.491 3.86234 28.1367 0.508057 23.999 0.508057Z"
					stroke="#0B1228"
					strokeOpacity="0.14"
					strokeWidth="1.017"
				/>
				<path
					d="M10.2195 13.9276C11.297 13.9276 11.8047 14.1194 12.585 14.8749L16.7708 18.9274C16.8946 19.0473 16.9194 19.0952 16.9441 19.1673C16.9565 19.1912 16.9565 19.2272 16.9565 19.2511C16.9565 19.2751 16.9565 19.311 16.9441 19.3351C16.9194 19.407 16.8946 19.4549 16.7708 19.5749L13.9101 22.3565C13.7862 22.4764 13.7366 22.5004 13.6624 22.5243C13.6376 22.5363 13.6005 22.5363 13.5756 22.5363C13.5509 22.5363 13.5137 22.5363 13.489 22.5243C13.4146 22.5004 13.3651 22.4764 13.2413 22.3565L5.12954 14.5031C4.89431 14.2753 4.98095 13.9276 5.3772 13.9276H10.2195Z"
					fill="#08CF65"
				/>
				<path
					d="M21.7804 8.66663C20.703 8.66663 20.1952 8.86938 19.415 9.66792L15.2291 13.9515C15.1052 14.0783 15.0806 14.1289 15.0557 14.2051C15.0434 14.2304 15.0434 14.2684 15.0434 14.2937C15.0434 14.319 15.0434 14.3572 15.0557 14.3825C15.0806 14.4585 15.1052 14.5091 15.2291 14.6359L18.0899 17.5635C18.2138 17.6903 18.2633 17.7156 18.3376 17.7409C18.3624 17.7536 18.3995 17.7536 18.4244 17.7536C18.449 17.7536 18.4861 17.7536 18.511 17.7409C18.5854 17.7156 18.6349 17.6903 18.7587 17.5635L26.8704 9.26224C27.1057 9.02149 27.019 8.66663 26.6228 8.66663H21.7804Z"
					fill="#08CF65"
				/>
			</g>
			<defs>
				<clipPath id="clip0_3059_499">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
